<ng-container *transloco="let t; read: 'ime.manufacturing.resources'">
  <ng-container *ngIf="(allItems$ | async | sortBy: 'Sequence' | sortBy: 'Code') as allItems; else loading">
    <ng-select #select class="select-sm form-control dropdown-auto-width"
               [items]="allItems"
               [name]="name"
               [placeholder]="placeholder"
               [virtualScroll]="true"
               [searchFn]="searchFn"
               [multiple]="multiple"
               [disabled]="readonly"
               [ngModel]="multiple ? entityIds : entityId" (ngModelChange)="multiple ? entityIds : entityId = $event"
               (change)="onSelectionChanged($event)"
               bindLabel="DisplayName"
               bindValue="Id"
               appendTo="body">
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label" [title]="item.DisplayName">{{item.DisplayName}}</span>
        <div ngbDropdown container="body" *ngIf="multiple">
          <span class="ng-value-icon right dropdown-toggle-without-arrow" (click)="select.close()" ngbDropdownToggle>
            <svg viewBox="0 0 6 8" class="icon small mb-1" inlineSVG="#bars-3"></svg>
            <div ngbDropdownMenu class="py-0">
              <div class="dropdown-header bg-teal-200 px-2 text-dark">{{item | displayName}}</div>
              <button type="button" ngbDropdownItem class="px-2" (click)="clear(item)" aria-hidden="true">
                <svg viewBox="0 0 8 8" class="icon small text-gray-600 me-1" inlineSVG="#x-mark"></svg>
                {{t('Remove')}}
              </button>
              <button type="button" ngbDropdownItem class="px-2" (click)="editExisting(item)">
                <svg viewBox="0 0 8 8" class="icon small text-gray-600 me-1" inlineSVG="#pencil"></svg>
                {{t('Edit')}}
              </button>
              <button type="button" ngbDropdownItem class="px-2" [ngClass]="{'active': isUserSpecified}" (click)="userSpecifiedChanged.emit(item)" *ngLet="item | isUserSpecified: userSpecifiedResourceIds as isUserSpecified">
                <span class="fw-bold ps-1 pe-2" [ngClass]="{'text-gray-600': !isUserSpecified, 'text-white': isUserSpecified}">!</span>
                {{t('User override')}}
                <span *ngIf="isUserSpecified" class="badge">
                  <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#check"></svg>
                </span>
              </button>
            </div>
          </span>
        </div>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
        <ng-container [ngTemplateOutlet]="option" [ngTemplateOutletContext]="{item: item, searchTerm: search}">
        </ng-container>
      </ng-template>
      <ng-template ng-footer-tmp>
        <ng-container [ngTemplateOutlet]="footer" [ngTemplateOutletContext]="{select: select}">
        </ng-container>
      </ng-template>
      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <ng-container [ngTemplateOutlet]="notfound"
                      [ngTemplateOutletContext]="{select: select, searchTerm: searchTerm}">
        </ng-container>
      </ng-template>
    </ng-select>
  </ng-container>
  <ng-template #loading>{{t('Loading')}}...</ng-template>
  <ng-template #notfound let-searchTerm="searchTerm" let-select="select">
    <div class="ng-option disabled">
      <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); addNew(searchTerm)" *ngIf="allowAdd">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        {{t('Add')}} "{{searchTerm}}"
      </button>
    </div>
  </ng-template>
  <ng-template #option let-item="item" let-searchTerm="searchTerm">
    <div class="d-flex justify-content-between text-wrap text-break ms-n1 bl-3 border-info">
      <span [ngOptionHighlight]="searchTerm">
        {{item.DisplayName}}
      </span>
      <a href="/manufacturing/resource/edit/{{item.Id}}" target="_blank" class="show-on-option-hover my-auto me-1" (click)="$event.stopPropagation()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#arrow-top-right-on-square"></svg>
      </a>
    </div>
  </ng-template>
  <ng-template #footer let-select="select">
    <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); addNew()" *ngIf="allowAdd">
      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus">
      </svg>
    </button>
    <button type="button" *ngIf="entityId || entityIds?.length" class="btn btn-sm btn-outline-primary me-1"
            (click)="select.close(); editExisting()">
      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
    </button>
  </ng-template>
</ng-container>
